import { paths } from 'src/routes/paths';

import packageJson from '../package.json';

// ----------------------------------------------------------------------

export const CONFIG = {
  site: {
    name: 'IGO2026',
    serverUrl: import.meta.env.VITE_SERVER_URL ?? '',
    assetURL: import.meta.env.VITE_ASSET_URL ?? '',
    basePath: import.meta.env.VITE_BASE_PATH ?? '',
    officialWebsite: import.meta.env.VITE_OFFICIAL_WEBSITE ?? '',
    version: packageJson.version,
  },
  /**
   * Auth
   * @method jwt 
   */
  auth: {
    method: 'jwt',
    skip: false, 
    redirectPath: paths.dashboard.root,
  },
  /**
   * Mapbox
   */
  mapbox: {
    apiKey: import.meta.env.VITE_MAPBOX_API_KEY ?? '',
  },
};
